<template>
  <div class="container">
    <!-- 头部标题 -->
    <div class="header">
      <span class="title">乐享分期计算器</span>
    </div>

    <!-- 输入卡片 -->
    <div class="card">
      <!-- 售价输入 -->
      <div class="field">
        <label class="label">售价</label>
        <div class="input-wrapper">
          <span class="currency">¥</span>
          <input
              type="number"
              v-model.number="price"
              placeholder="请输入售价"
          />
        </div>
      </div>

      <!-- 方案选择（点击触发底部弹窗） -->
      <div class="field">
        <label class="label">方案</label>
        <div class="picker-trigger" @click="showPicker = true">
          <span class="picker-text">{{ selectedPlanText || '请选择方案' }}</span>
          <span class="arrow">▼</span>
        </div>
      </div>
    </div>

    <!-- 费用总览 -->
    <div class="card" v-if="showSummary">
      <h2 class="section-title">费用总览</h2>
      <div class="row">
        <span>费率：</span>
        <span class="value">{{ rate }}%</span>
      </div>
      <div class="row">
        <span>总租金：</span>
        <span class="value">¥{{ totalRent.toFixed(2) }}元</span>
      </div>
      <div class="row">
        <span>首付金额：</span>
        <span class="value">¥{{ downPayment.toFixed(2) }}元</span>
      </div>

      <h2 class="section-title" style="margin-top: 20px;">账单详情</h2>
      <div v-for="(item, index) in billList" :key="index" class="bill-item">
        <span>第{{ index + 1 }}期</span>
        <span class="bill-tag" v-if="isDownPaymentTerm(index)">首付</span>
        <span class="value">¥{{ item.toFixed(2) }}元</span>
      </div>
    </div>

    <!-- 计算按钮 -->
    <button class="calculate-btn" @click="calculate">开始计算</button>

    <!-- 底部弹窗（方案选择） -->
    <div class="picker-mask" v-if="showPicker" @click="showPicker = false"></div>
    <transition name="slide-up">
      <div class="picker-panel" v-if="showPicker">
        <div class="picker-header">
          <span class="picker-cancel" @click="showPicker = false">取消</span>
          <span class="picker-title">选择方案</span>
          <span class="picker-confirm" @click="confirmPicker">确定</span>
        </div>
        <div class="picker-options">
          <div
              class="picker-option"
              v-for="(plan, index) in planOptions"
              :key="index"
              :class="{ active: tempPlanIndex === index }"
              @click="tempPlanIndex = index"
          >
            {{ plan.text }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      price: '',
      selectedPlanIndex: 0,
      tempPlanIndex: 0,
      showPicker: false,
      planOptions: [
        { text: '首付20% | 费率20% | 6期', downPaymentRate: 0.2, rate: 0.2, terms: 6, downPaymentTerms: [0] },
        { text: '首付30% | 费率17% | 6期', downPaymentRate: 0.3, rate: 0.17, terms: 6, downPaymentTerms: [0, 5] },
        { text: '首付35% | 费率15% | 6期', downPaymentRate: 0.35, rate: 0.15, terms: 6, downPaymentTerms: [0, 5] },
        { text: '首付40% | 费率14% | 6期', downPaymentRate: 0.4, rate: 0.14, terms: 6, downPaymentTerms: [0, 5] },
        { text: '首付50% | 费率10% | 6期', downPaymentRate: 0.5, rate: 0.1, terms: 6, downPaymentTerms: [0, 4, 5] },
        { text: '首付65% | 费率5% | 6期', downPaymentRate: 0.65, rate: 0.05, terms: 6, downPaymentTerms: [0, 3, 4, 5] }
      ],
      totalRent: 0,
      downPayment: 0,
      billList: []
    }
  },
  computed: {
    selectedPlanText() {
      return this.planOptions[this.selectedPlanIndex]?.text || ''
    },
    selectedPlan() {
      return this.planOptions[this.selectedPlanIndex] || {}
    },
    rate() {
      return (this.selectedPlan.rate * 100).toFixed(2)
    },
    showSummary() {
      return this.price && this.selectedPlanText && parseFloat(this.price) > 0 && this.totalRent > 0
    }
  },
  methods: {
    confirmPicker() {
      this.selectedPlanIndex = this.tempPlanIndex
      this.totalRent = 0
      this.downPayment = 0
      this.billList = []
      this.showPicker = false
    },
    isDownPaymentTerm(index) {
      const terms = this.selectedPlan.downPaymentTerms || []
      return terms.includes(index)
    },
    calculate() {
      if (!this.price || !this.selectedPlanText) {
        alert('请填写售价并选择方案')
        return
      }
      const priceNum = parseFloat(this.price)
      if (isNaN(priceNum) || priceNum <= 0) {
        alert('请输入有效的售价')
        return
      }

      const plan = this.selectedPlan
      // 总租金 = 售价 * (1 + 费率)
      this.totalRent = priceNum * (1 + plan.rate)
      // 首付总额 = 售价 * 首付比例（修正点）
      this.downPayment = priceNum * plan.downPaymentRate

      const downPaymentTerms = plan.downPaymentTerms || []
      const downPaymentCount = downPaymentTerms.length
      // 单期首付金额（首付总额分摊到每个首付期）
      const perDownPayment = downPaymentCount > 0 ? this.downPayment / downPaymentCount : 0

      // 剩余总额 = 总租金 - 首付总额
      const remaining = this.totalRent - this.downPayment
      const remainingTerms = plan.terms - downPaymentCount
      const periodAmount = remainingTerms > 0 ? remaining / remainingTerms : 0

      // 生成账单列表
      this.billList = []
      for (let i = 0; i < plan.terms; i++) {
        if (downPaymentTerms.includes(i)) {
          this.billList.push(perDownPayment)
        } else {
          this.billList.push(periodAmount)
        }
      }
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  margin: 0;
  padding: 10px;
}

#app {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  background: #ffffff;
}

.container {
  padding: 16px;
  position: relative;
  min-height: 100vh;
}

.header {
  margin-bottom: 20px;
  text-align: center;
}

.title {
  font-size: 32px;
  font-weight: bold;
  color: #e4393c;
  display: block;
  letter-spacing: 2px;
}

.card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
}

.field {
  margin-bottom: 20px;
}

.field:last-child {
  margin-bottom: 0;
}

.label {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 0 12px;
  background-color: #fafafa;
}

.currency {
  font-size: 18px;
  color: #e4393c;
  margin-right: 6px;
  font-weight: 500;
}

.input-wrapper input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  padding: 14px 0;
  font-size: 16px;
  color: #333;
  width: 100%;
}

/* 方案选择触发器 */
.picker-trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 14px 12px;
  background-color: #fafafa;
  cursor: pointer;
}

.picker-text {
  font-size: 16px;
  color: #333;
}

.arrow {
  font-size: 14px;
  color: #999;
}

/* 底部弹窗遮罩 */
.picker-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

/* 底部弹窗面板 */
.picker-panel {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  z-index: 1001;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

/* 滑入动画 */
.slide-up-enter-active, .slide-up-leave-active {
  transition: transform 0.3s ease;
}
.slide-up-enter-from, .slide-up-leave-to {
  transform: translateY(100%);
}

.picker-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
}

.picker-cancel, .picker-confirm {
  color: #e4393c;
  cursor: pointer;
}

.picker-title {
  font-weight: 600;
  color: #333;
}

.picker-options {
  max-height: 300px;
  overflow-y: auto;
}

.picker-option {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}

.picker-option:active {
  background-color: #f5f5f5;
}

.picker-option.active {
  color: #e4393c;
  font-weight: 500;
  background-color: #ffeaea;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  border-left: 4px solid #e4393c;
  padding-left: 12px;
  display: block;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
  color: #666;
}

.row:last-child {
  border-bottom: none;
}

.value {
  font-weight: 600;
  color: #e4393c;
  font-size: 16px;
}

.bill-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  font-size: 16px;
  color: #666;
}

.bill-item:last-child {
  border-bottom: none;
}

.bill-tag {
  background-color: #ffeaea;
  color: #e4393c;
  font-size: 13px;
  padding: 2px 8px;
  border-radius: 20px;
  margin-left: 8px;
}

.calculate-btn {
  width: 100%;
  background-color: #e4393c;
  color: white;
  font-size: 18px;
  font-weight: 600;
  padding: 16px;
  border: none;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(228, 57, 60, 0.3);
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 10px;
}

.calculate-btn:active {
  opacity: 0.9;
  transform: scale(0.98);
}
</style>